import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// This is better than clsx...
// https://www.reddit.com/r/tailwindcss/comments/1egbuvx/the_buzz_around_cn_function_and_why_do_we_use_it/
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const roundDownToNearest = (val: number, nearest: number) => {
  if (val < 50) {
    const roundedToTen = Math.floor(val / 10) * 10
    if (roundedToTen === 0) return 10
    return roundedToTen
  }
  const rounded = Math.floor(val / nearest) * nearest
  if (rounded === 0) return nearest
  return rounded
}

export const stripPhoneNumber = (phone: string) => {
  return phone.replace(/\D/g, "")
}

export const formatPhoneNumber = (value?: string) => {
  const cleaned = ("" + value).replace(/\D/g, "")
  const len = cleaned.length

  if (len < 4) {
    return cleaned
  }

  if (len < 7) {
    return "(" + cleaned.substring(0, 3) + ") " + cleaned.substring(3)
  }

  // For 7 or more digits
  return (
    "(" +
    cleaned.substring(0, 3) +
    ") " +
    cleaned.substring(3, 6) +
    "-" +
    cleaned.substring(6)
  )
}

export const normalizePhoneNumberForSupabase = (phone: string) => {
  const cleaned = phone.replace(/\D/g, "")
  if (cleaned.length === 10) {
    return "1" + cleaned
  }
  if (cleaned.length !== 11) throw new Error("Phone number is too short")
  return cleaned
}
